import { useSprings } from '@react-spring/web'
import {
    controlWidthMedium,
    controlWidthSmall,
    downloadFormButtonIdleWidthSmall,
    downloadFormButtonOffset,
    downloadFormButtonWidthMedium,
    downloadFormButtonWidthSmall,
    downloadFormExpandedWidth,
    downloadFormHeaderIdleWidth,
    downloadFormInputRightSmall,
} from '@styles/variables'
import type { LiteralUnion } from 'type-fest'

const widthMedium = parseInt(controlWidthMedium) || 250
const widthSmall = parseInt(controlWidthSmall) || 180
const expandedWidth = parseInt(downloadFormExpandedWidth) || 360
const buttonOffset = parseInt(downloadFormButtonOffset) || 260
const buttonWidthMedium = parseInt(downloadFormButtonWidthMedium) || 100
const buttonWidthSmall = parseInt(downloadFormButtonWidthSmall) || 75
const buttonIdleWidthSmall = parseInt(downloadFormButtonIdleWidthSmall) || 100
const headerIdleWidth = parseInt(downloadFormHeaderIdleWidth) || 116
const inputRightSmall = parseInt(downloadFormInputRightSmall) || 85

const STYLES = {
    form: {
        medium: {
            focused: { width: expandedWidth },
            idle: { width: widthMedium },
        },
        small: {
            focused: {},
            idle: {},
        },
    },
    button: {
        medium: {
            focused: { left: buttonOffset, width: buttonWidthMedium },
            idle: { left: 0, width: widthMedium },
        },
        small: {
            focused: { right: 0, width: buttonWidthSmall },
            idle: { right: 0, width: buttonIdleWidthSmall },
        },
    },

    input: {
        medium: {
            focused: {
                width: widthMedium,
                opacity: 1,
                transform: 'scale(1)',
                transformOrigin: 'right',
            },
            idle: {
                opacity: 0,
                transform: 'scale(0)',
            },
        },
        small: {
            focused: {
                opacity: 1,
                transform: 'scale(1)',
                width: widthSmall,
                transformOrigin: 'center',
                right: inputRightSmall,
            },
            idle: {
                opacity: 0,
                width: 0,
                right: 0,
                transform: 'scale(0)',
            },
        },
    },
}

export const useButtonRolloutAnimation = (
    status: 'focused' | 'idle',
    size: 'small' | 'medium',
    placement?: LiteralUnion<
        'footer' | 'section' | 'header' | 'banner',
        string
    >,
) => {
    // override closed form width if placement is header
    const formValues =
        placement === 'header' && status === 'idle'
            ? {
                  ...STYLES.form[size][status],
                  width: headerIdleWidth,
              }
            : STYLES.form[size][status]

    const [inputStyles, buttonStyles, formStyles] = useSprings(3, [
        {
            ...STYLES.input[size][status],
            config: { tension: 170, friction: 26 },
        },
        {
            ...STYLES.button[size][status],
            config: { tension: 210, friction: 20 },
        },
        {
            ...formValues,
            config: { tension: 200, friction: 20 },
        },
    ])

    return { inputStyles, buttonStyles, formStyles }
}
